module.exports = __webpack_public_path__ + "img/wfqd-icon.e6287d1f.png";